
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","viewBox":"0 0 30 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#c60c30","d":"M0 0h30v20H0z"}}),_c('path',{attrs:{"d":"M0 8.378h9.73v-9.73h3.243v9.73H30v3.244H12.973v9.73H9.73v-9.73H0V8.378z","fill":"#fff"}})])
          )
        }
      }
    